import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { loader } from './../layout/loader';

import Root from './_Root';

const rootDiv = document.getElementById('activity-feed');

function initApp(data, divTemplate) {
    ReactDOM.render(<Root results={data} template={divTemplate} />, rootDiv);
}

function init() {
    if (rootDiv !== null) {
        const rootTemplate = rootDiv.getAttribute('data-template');

        loader.show();
        axios({
            method: 'get',
            url: rootDiv.getAttribute('data-url') + '?q=&type=0&from=null&to=null&length=10&start=0',
            responseType: 'json',
        })
        .then((response) => {
            initApp(response.data, rootTemplate);
            loader.hide();
        })
        .catch((response) => {
            console.log(response);
        });
    }
}

export { init };



// WEBPACK FOOTER //
// ./src/_app/activity-feed/index.js